import type { ViewProps } from "./types";
import { StatItem, getSizing } from "../parts/StatItem";
import { radiusClass, shadowClass } from "../parts/themeTokens";
import { shade } from "../parts/StatItem";

export function CardsView({ cfg, items, theme }: ViewProps) {
  const cols = items.length === 1 ? "grid-cols-1" : items.length === 2 ? "grid-cols-2" : items.length === 3 ? "grid-cols-3" : "grid-cols-2 sm:grid-cols-4";
  const gap = cfg.density === "compact" ? "gap-2" : cfg.density === "comfortable" ? "gap-4" : "gap-3";
  const pad = cfg.density === "compact" ? "p-2" : cfg.density === "comfortable" ? "p-5 sm:p-6" : "p-4 sm:p-5";
  const cardPad = cfg.density === "compact" ? "px-3 py-3" : getSizing(cfg.size).pad;
  const radius = radiusClass(cfg.radius);
  const shadow = shadowClass(cfg.shadow, theme === "transparent");
  const borderClass = cfg.border ? "border" : "";
  return (
    <div className={"grid h-full " + cols + " " + gap + " " + pad}>
      {items.map((it, i) => (
        <div
          key={it.k}
          className={
            "relative overflow-hidden " + radius + " " + borderClass + " " + shadow + " " + cardPad
          }
          style={{
            background: "var(--lm-card-bg)",
            borderColor: "var(--lm-card-border)",
          }}
        >
          {/* Top accent line */}
          <span
            aria-hidden
            className="absolute inset-x-0 top-0 h-[3px]"
            style={{
              background: `linear-gradient(90deg, var(--lm-accent) 0%, ${shade(cfg.accent, -0.18)} 100%)`,
            }}
          />
          {/* Soft glow */}
          <span
            aria-hidden
            className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full opacity-[0.08] blur-2xl"
            style={{ background: "var(--lm-accent)" }}
          />
          <StatItem k={it.k} value={it.value} label={it.label} cfg={cfg} delayMs={i * 80} />
        </div>
      ))}
    </div>
  );
}
